import { Dropdown, PopoverContent, SelectDropdown } from '@sketch/components'
import { ModalHeader } from '@sketch/components/src/Modal/ModalHeader'
import { breakpoint } from '@sketch/global-styles'
import styled from 'styled-components'

export const Icon = styled.svg`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 8px;
`

export const SelectInside = styled.span`
  display: inline-flex;
  align-items: center;
`

export const Abbr = styled.abbr`
  && {
    text-decoration: none;
  }

  ::after {
    margin-left: 4px;
    content: '(' attr(title) ')';
  }
`

export const Select = styled(SelectDropdown)`
  display: inline-flex;
  width: 200px;
  padding: 8px 12px;
  margin-right: 12px;

  & ~ span[data-testId='popover-content-wrapper'] ${PopoverContent} {
    width: 200px;
  }

  ${breakpoint('base', 'sm')`
    width: 100px;
    min-height: 32px;
    padding: 8px 10px;

    ${Abbr}::after {
      display: none;
    }

    ${Icon} {
      width: 17px;
      height: 17px;
    }
  `}
` as typeof SelectDropdown

export const SelectHeader = styled(Dropdown.Header)`
  text-transform: none;
  margin-left: 12px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  ${breakpoint('sm')`
    ${ModalHeader} & {
        margin-left: -12px;
      }
  `}
`
